module.exports = __webpack_public_path__ + "static/media/clean5.279bd30a.jpg";